module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="mobile_description_container">\n	';
 if(currentAlbum.campaign){ ;
__p += '\n	<div id="vote_button_holder">\n		';
 if(!voted()){ ;
__p += '<a href="#" id="vote_button"><div id="vote_heart"></div></a>';
 };
__p += '\n		';
 if(voted()){ ;
__p += '<a href="#" id="vote_button" class="voted"><div id="vote_heart"></div></a>';
 };
__p += '\n	</div>\n	';
 };
__p += '\n	';
  if (hasActionLink()) { ;
__p += '	\n	<div id="buynow_button_holder">\n		<img src="" style="display:none;">\n		<a id="action_link_anchor" href="' +
((__t = ( decode_utf8(getActionLink()) )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( decode_utf8(getActionText()) )) == null ? '' : __t) +
'\n		</a>\n	</div>\n	';
 } ;
__p += '\n	\n	<div class="clearfix"></div>\n	\n	<div id="user_info_holder">\n		' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'\n	</div>\n\n	<div id="caption_holder">\n		<p>';
 if (shouldShowCaptions()){;
__p += ' ' +
__e( decode_utf8(getTitle()) ) +
' ';
 };
__p += '</p>\n	</div>\n</div>\n';

}
return __p
}